// src/components/DrinksMenuComponent.tsx
import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './MenuComponent.css'; // Reuse the same styles

interface DrinksMenuItem {
    id: number;
    titleEn: string;
    titleDa: string;
    image: string;
    link: string;
}

const defaultDrinksMenuItems: DrinksMenuItem[] = [
    {
        id: 1,
        titleEn: 'Drinks Allowance',
        titleDa: 'Drinks Godtgørelse',
        image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/1.png',
        link: '/admin/drinks/allowance',
    },
    {
        id: 2,
        titleEn: 'Manage bars and invoices',
        titleDa: 'Adminitrer bar og faktura',
        image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/8.png',
        link: '/admin/event-bars',
    },
    {
        id: 3,
        titleEn: 'Bar Overview',
        titleDa: 'Bar Oversigt',
        image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/8.png',
        link: '/admin/drinks/overview',
    },
    {
        id: 4,
        titleEn: 'Collections',
        titleDa: 'Collections',
        image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/8.png',
        link: '/admin/drink-ticket-collections',
    },
    {
        id: 5,
        titleEn: 'Tickets print',
        titleDa: 'Tickets print',
        image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/8.png',
        link: '/admin/drink-ticket-print',
    },
    // Add more event-specific options here
];

interface DrinksMenuProps {
    eventID?: number; // Optional: append eventID to links
    itemsToShow?: number[];
}

const DrinksMenuComponent: React.FC<DrinksMenuProps> = ({ eventID, itemsToShow }) => {
    const { language } = useLanguage();

    const filteredMenuItems = itemsToShow
        ? defaultDrinksMenuItems.filter((item) => itemsToShow.includes(item.id))
        : defaultDrinksMenuItems;

    return (
        <div className="menu-grid">
            {filteredMenuItems.map((item) => {
                const link = eventID ? `${item.link}/${eventID}` : item.link;
                return (
                    <div key={item.id} className="menu-card">
                        <a href={link}>
                            <img
                                src={item.image}
                                alt={language === 'da' ? item.titleDa : item.titleEn}
                                className="menu-image"
                            />
                            <div className="menu-title">
                                {language === 'da' ? item.titleDa : item.titleEn}
                            </div>
                        </a>
                    </div>
                );
            })}
        </div>
    );
};

export default DrinksMenuComponent;
